import {useQuery} from '@apollo/client';
import {GET_SORTER_PLAN_LISTING, SorterPlanFiltersInput, SorterPlanPageRequestInput} from '../graphql/queries/getSorterPlanListing';

export interface SorterPlanFiltersType {
    sorterPlanName?: string;
    status?: number;
    sorterId?: number;
    sorterIds?: number[];
    warehouseId?: number;
    sorterType?: number;
}

export const useSorterPlanQuery = (filters: SorterPlanFiltersType, page: number, pageSize: number) => {
    const filtersInput: SorterPlanFiltersInput = {
        sorterPlanName: filters.sorterPlanName,
        status: filters.status,
        sorterId: filters.sorterId,
        sorterIds: filters.sorterIds,
        warehouseId: filters.warehouseId,
        sorterType: filters.sorterType
    };

    const pageRequest: SorterPlanPageRequestInput = {
        page,
        size: pageSize
    };

    const {data, loading, error, refetch} = useQuery(GET_SORTER_PLAN_LISTING, {
        variables: {
            filters: filtersInput,
            pageRequest
        },
        fetchPolicy: 'network-only'
    });

    return {
        data: data?.getSorterPlanListing?.content || [],
        totalElements: data?.getSorterPlanListing?.totalElements || 0,
        totalPages: data?.getSorterPlanListing?.totalPages || 0,
        loading,
        error,
        refetch
    };
};

